export enum Option {
  OR = 'OR',
  AND = 'AND',
}
